import CircularProgress from '@mui/material/CircularProgress';

const SPINNER_INDIGO = '#3f51b5';
const SPINNER_SX = { color: SPINNER_INDIGO };

const LoadingSpinner = (props) => (
  <CircularProgress sx={SPINNER_SX} {...props} />
);

export default LoadingSpinner;
